import React from "react";

import { useEditCost } from "@planzone/view-models";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { TrashIcon } from "@common/trashIcon";
import { Props } from "./types";
import { NumberInput } from "./numberInput";
import { DateInput } from "./dateInput";
import styles from "./styles.scss";

function Cost({ cost }: Props) {
  const { pushView } = useModal();
  const { isRequestPending, editCost } = useEditCost(cost);
  const [formData, setFormData] = React.useState(cost);
  const submit = () =>
    !isRequestPending && editCost({ nextCost: formData, cost });

  React.useEffect(() => {
    setFormData(cost);
  }, [cost]);

  return (
    <div className={styles.cost}>
      <div className={styles.row}>
        <NumberInput
          className={styles.text}
          nbr={formData.cost}
          edit={(cost) => setFormData({ ...formData, cost })}
          submit={submit}
        />
        <DateInput
          date={cost.startDate}
          edit={(startDate) =>
            editCost({ nextCost: { ...formData, startDate }, cost })
          }
        />
      </div>
      <div
        className={styles.iconBox}
        onClick={() =>
          pushView({
            key: UseCases.removeCost,
            data: cost,
          })
        }
      >
        <TrashIcon className={styles.icon} />
      </div>
    </div>
  );
}

export { Cost };
